__turbopack_context__.v({
  "checkbox": "MultiChoiceQuestion-module__uixM2a__checkbox",
  "checkboxWrapper": "MultiChoiceQuestion-module__uixM2a__checkboxWrapper",
  "optionsList": "MultiChoiceQuestion-module__uixM2a__optionsList",
});
